import { createPortal } from "react-dom";
import ConfirmModal from "../../../../../components/confirmViewModal/ConfirmModal";
import { Form } from "../../../../../components/ui/common/form";
import PackagingLevelUnitSection from "./components/PackagingLevelUnitSection";
import PackagingMaterialsSection from "./components/PackagingMaterialsSection";
import PackagingSectionCollapsible from "./components/PackagingSectionCollapsible";
import { usePackagingLevelForm } from "./hooks/usePackagingLevelForm";
import { usePackagingLevelMaterials } from "./hooks/usePackagingLevelMaterials";
import { usePackagingLevelUnit } from "./hooks/usePackagingLevelUnit";
import { PackagingLevelProps } from "./packagingLevel.types";

const PackagingLevel = (props: PackagingLevelProps) => {
  const { form } = usePackagingLevelForm();
  const { levelMeta, sectionProps, unitSectionProps, showMaterialsSection, openAccordion } =
    usePackagingLevelUnit({ ...props, form });
  const { materialsSectionProps, deleteModalProps } = usePackagingLevelMaterials({
    ...props,
    form,
    showMaterialsSection,
    openAccordion
  });

  if (!levelMeta) return null;

  return (
    <>
      <PackagingSectionCollapsible {...sectionProps}>
        <Form {...form}>
          <div className="tw-space-y-3">
            {unitSectionProps && <PackagingLevelUnitSection {...unitSectionProps} />}
            {materialsSectionProps && <PackagingMaterialsSection {...materialsSectionProps} />}
          </div>
        </Form>
      </PackagingSectionCollapsible>

      {deleteModalProps.visible &&
        createPortal(
          <ConfirmModal
            viewModal={deleteModalProps.visible}
            closeModal={deleteModalProps.onClose}
            cancel={deleteModalProps.onCancel}
            approve={deleteModalProps.onConfirm}
            title={deleteModalProps.title}
            subTitle={deleteModalProps.subTitle}
          />,
          document.body
        )}
    </>
  );
};

export default PackagingLevel;
